import { CONSTRAINED } from '../../store/actionTypes';
export const initialState = {
    "symbol_table": [
        {
            "input": true,
            "name": "Length",
            "value": 30,
            "units": "cm",
            "lmin": CONSTRAINED,
            "lmax": 0,
            "cmin": 0.1,
            "cmax": 250.00,
            "validmin": 0.0,
            "validmax": Number.MAX_VALUE,
            "sdlim": 1,
            "tooltip": "<Table><tr><td>Longest dimension</td></tr><tr><td class=\"text-center\"><Image fluid src=\"/designtypes/Solid/tooltips/Length.png\"/></td></tr></Table>",
            "type": "equationset",
            "hidden": false
        },
        {
            "input": true,
            "name": "Width",
            "value": 25,
            "units": "cm",
            "lmin": CONSTRAINED,
            "lmax": 0,
            "cmin": 0.1,
            "cmax": 200,
            "validmin": 0.0,
            "validmax": Number.MAX_VALUE,
            "sdlim": 1,
            "tooltip": "<Table><tr><td>Width dimension</td></tr><tr><td class=\"text-center\"><Image fluid src=\"/designtypes/Solid/tooltips/Width.png\"/></td></tr></Table>",
            "type": "equationset",
            "hidden": false
        },
        {
            "input": true,
            "name": "Height",
            "value": 20,
            "units": "cm",
            "lmin": CONSTRAINED,
            "lmax": 0,
            "cmin": 0.1,
            "cmax": 150,
            "validmin": 0.0,
            "validmax": Number.MAX_VALUE,
            "sdlim": 1,
            "tooltip": "<Table><tr><td>Shortest dimension</td></tr><tr><td class=\"text-center\"><Image fluid src=\"/designtypes/Solid/tooltips/Height.png\"/></td></tr></Table>",
            "type": "equationset",
            "hidden": false
        },
        {
            "input": true,
            "name": "Material",
            "value": 7,
            "units": "",
            "format": "table",
            "table": "Solid/mat_metric",
            "lmin": 0,
            "lmax": 0,
            "cmin": 0,
            "cmax": 0,
            "sdlim": 0,
            "tooltip": "Select from list",
            "type": "calcinput",
            "hidden": false
        },
        {
            "input": true,
            "name": "Density",
            "value": 1.0,
            "units": "g/cm3",
            "lmin": 0,
            "lmax": 0,
            "cmin": 0,
            "cmax": 0,
            "validmin": 0.0,
            "validmax": Number.MAX_VALUE,
            "sdlim": 0,
            "tooltip": "Weight per unit volume of the selected material",
            "type": "calcinput",
            "hidden": false
        },
        {
            "input": false,
            "name": "Volume",
            "value": 0,
            "units": "cc",
            "lmin": 0,
            "lmax": 0,
            "cmin": 1.0,
            "cmax": 20000.0,
            "validmin": 0.0,
            "validmax": Number.MAX_VALUE,
            "sdlim": 1,
            "tooltip": "Three-dimensional space enclosed",
            "type": "equationset",
            "hidden": false
        },
        {
            "input": false,
            "name": "Surface Area",
            "value": 0,
            "units": "cm2",
            "lmin": 0,
            "lmax": 0,
            "cmin": 0,
            "cmax": 6000,
            "validmin": 0.0,
            "validmax": Number.MAX_VALUE,
            "sdlim": 1,
            "tooltip": "Sum of the area of the surfaces",
            "type": "equationset",
            "hidden": false
        },
        {
            "input": false,
            "name": "VolToSurfArea",
            "value": 0,
            "units": "ratio",
            "lmin": 0,
            "lmax": 0,
            "cmin": 0,
            "cmax": 10,
            "validmin": 0.0,
            "validmax": Number.MAX_VALUE,
            "sdlim": 0.01,
            "tooltip": "Computed ratio of volume to surface area",
            "type": "equationset",
            "hidden": false
        },
        {
            "input": false,
            "name": "Girth",
            "value": 0,
            "units": "cm",
            "lmin": 0,
            "lmax": 0,
            "cmin": 0,
            "cmax": 250.0,
            "validmin": 0.0,
            "validmax": Number.MAX_VALUE,
            "sdlim": 1,
            "tooltip": "<Table><tr><td>Perimeter around width and height dimensions</td></tr><tr><td class=\"text-center\"><Image fluid src=\"/designtypes/Solid/tooltips/Girth.png\"/></td></tr></Table>",
            "type": "equationset",
            "hidden": false
        },
        {
            "input": false,
            "name": "Length+Girth",
            "value": 0,
            "units": "cm",
            "lmin": 0,
            "lmax": CONSTRAINED,
            "cmin": 0,
            "cmax": 275.0,
            "validmin": 0.0,
            "validmax": Number.MAX_VALUE,
            "sdlim": 1,
            "tooltip": "Sum of length and girth dimensions.<br/>Shippers may limit to ~275 cm.",
            "type": "equationset",
            "hidden": false
        },
        {
            "input": false,
            "name": "Diagonal",
            "value": 0,
            "units": "cm",
            "lmin": 0,
            "lmax": 0,
            "cmin": 0,
            "cmax": 250.,
            "validmin": 0.0,
            "validmax": Number.MAX_VALUE,
            "sdlim": 1,
            "tooltip": "3D distance from corner to furthest corner",
            "type": "equationset",
            "hidden": false
        },
        {
            "input": false,
            "name": "Weight",
            "value": 0,
            "units": "grams",
            "lmin": 0,
            "lmax": CONSTRAINED,
            "cmin": 0,
            "cmax": 30000.0,
            "validmin": 0.0,
            "validmax": Number.MAX_VALUE,
            "sdlim": 0.1,
            "tooltip": "<Table><tr><td>Volume times Density of the selected material.<br/>Shippers may limit to 30 kg.</td></tr><tr><td class=\"text-center\"><Image fluid src=\"/designtypes/Solid/tooltips/Weight.png\"/></td></tr></Table>",
            "type": "equationset",
            "hidden": false
        }
    ],
    "labels": [
        {
            "name": "COMMENT",
            "value": "Rectangular Solid default start point - Metric units ..."
        }
    ],
    "type": "Solid",
    "version": "10",
    "result": {
        "objective_value": 0,
        "termination_condition": ""
    },
    "jsontype": "ODOP",
    "units": "US"
};
